<template>
    <div class="overlay-loader">
        <LoadingSpinner :size="120" />
    </div>
</template>

<script lang="ts" setup>
import LoadingSpinner from "@/components/common/LoadingSpinner.vue";
</script>

<style scoped>
/* parent needs to have 'position: relative' for this to work */
.overlay-loader {
    position: absolute;
    top: 0;
    left: 0;

    z-index: 1000;

    width: 100%;
    height: 100%;

    background-color: rgba(255, 255, 255, 0.9);

    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
